import { Loading, Authenticated, useGetOne, GetOneParams } from "react-admin";

export default function OtpUsages() {
  const {
    data: dataOtpUsages,
    isLoading: loadingOtpUsages,
    error: errorOtpUsages,
  } = useGetOne("dashboard", { id: 299 } as GetOneParams);

  if (loadingOtpUsages) {
    return <Loading />;
  }

  if (errorOtpUsages) {
    console.error({ error: errorOtpUsages });
  }

  return (
    <Authenticated>
      <iframe
        style={{ border: "none" }}
        src={dataOtpUsages.metabaseUrl}
        width="100%"
        height="100%"
        allowTransparency
        title="OTP Usage"
      />
    </Authenticated>
  );
}
